document.addEventListener("DOMContentLoaded", function () {
  requestAnimationFrame(() => {
document
  .getElementById("personalize-design")
  .addEventListener("click", function () {
    var productForm = document.querySelector(".shopify-product-form");
    var serializedData = new FormData(productForm);


    //console.log('click animation v25');

    if (serializedData) {
      document.getElementById("personalize-design").textContent =
        "Please wait.....";

      fetch(
        "https://printonvinyls.com/marinevinylfabric/designnbuy/pcstudio_config/getIframeurl",
        {
          method: "POST",
          body: serializedData
        }
      )
      .then(response => {
        //console.log("Status:", response.status);
        if (!response.ok) {
          throw new Error("Network response was not ok " + response.statusText);
        }
        return response.text();
      })
      .then(responseText => {
        //console.log("redirect: " + responseText);
        if (responseText) {
          var url = new URL(responseText);
          var productId = productForm.querySelector('input[name="product-id"]')?.value;
          var selectedVariant = parseInt(productForm.querySelector('input[name="id"]')?.value);
          var sizeId = product.variants.find(v => v.id === selectedVariant)?.option_values[0];
          
          // Use textContent directly instead of DOMParser for better performance
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = sizeId;
          const decodedSizeId = tempDiv.textContent || tempDiv.innerText || sizeId;
          
          url.searchParams.set("product_id", productId);
          url.searchParams.set("size_id", decodedSizeId);
          
          window.location.href = url.toString();
        }
      })
      .catch(error => {
        console.error("Request failed:", error);
        document.getElementById("personalize-design").textContent = "Error";
      });
    } else {
      console.error("serializedData is not defined");
    }
  });
  });
});